export const catchErrors = (errors?: any, apiName?: any) => {
  console.log("error caught in catch block", errors, apiName);
};
